import React, { useEffect, useState } from "react";
import "./App.css";
import MyBook from "./components/modules/Mybook";
import ListSites from "./components/modules/ListSites";
import Seo from "./components/global/Seo";
import SocialMedia from "./components/modules/SocialMedia";
import GoogleAds from "./components/modules/GoogleAds";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Siteconfig from "./components/data/Siteconfig.json";
import BackgroundAudioPlayer from "./components/modules/Backgroundmusic";

const App = () => {
  const [siteData, setSiteData] = useState([]);
  useEffect(() => {
    const fetchSiteData = async () => {
      const sitesWithData = await Promise.all(
        Siteconfig.sites.map(async (site) => {
          if (window.location.pathname.includes(site.routePath)) {
            const jsonData = await Promise.all(
              site.jsonData.map(async (path) => {
                const data = await import(
                  /* webpackChunkName: "[request]" */ `${path}`
                );
                return data.default;
              })
            );
            // Dynamically import the SCSS file
            const scssPath = site.scssPath || "./components/themes/custom.scss";
            await import(/* webpackChunkName: "siteStyles" */ `${scssPath}`);
            return { ...site, jsonData: jsonData.flat() };
          }
        })
      );
      let newArray = [];
      sitesWithData.forEach((ele) => {
        if (ele) {
          let data = [];
          let obj = {};
          ele.jsonData.forEach((jd, i) => {
            data.push(...jd.data);
            if (i === ele.jsonData.length - 1) {
              obj = { ...jd, data: [...data] };
            }
          });
          newArray.push({ ...ele, jsonData: obj });
        }
      });
      setSiteData(newArray);
    };
    fetchSiteData();
  }, []);
  return (
    <div className="app">

      <Router>
        <Routes>
          <Route
            path="/assets"
            element={<ListSites siteList={Siteconfig.siteList} />}
          />
          {siteData.map((site, index) => (
            <Route
              key={index}
              path={site.routePath}
              element={
                <>
                  <Seo data={site.objSeo} />
                  <div className="content-wrapper">
                    {site.showAds && <GoogleAds />}
                    <MyBook pages={site.jsonData} />
                    {site.audio && <BackgroundAudioPlayer src="images/yahvi/audio.mp3"></BackgroundAudioPlayer>}
                    <SocialMedia site={site} />
                    

                  </div>
                </>
              }
            />
          ))}
        </Routes>
      </Router>
    </div>
  );
};
export default App;
